import { LoginContainerComponent } from '@stockcare-views/authentication/login-container/login-container.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LinkDeviceComponent } from './link-device/link-device.component';
import { DeviceDeactivatedComponent } from './device-deactivated/device-deactivated.component';
import { DeviceNeedsToBeLinkedComponent } from './device-needs-to-be-linked/device-needs-to-be-linked.component';
import { Roles } from '@stockcare-helpers/roles';
import { AuthorisationAuthGuardService } from '@stockcare-guards/authorisation-auth-guard.service';

const routes: Routes = [
  {
    path: 'login',
    component: LoginContainerComponent,
  },
  {
    path: 'linkdevice',
    component: LinkDeviceComponent,
    canActivate: [AuthorisationAuthGuardService],
    data: {
      roles: [
        Roles.systemAdministrator,
        Roles.superAdministrator,
        Roles.hospitalAdministrator,
      ],
    },
  },
  {
    path: 'devicedeactivated',
    component: DeviceDeactivatedComponent,
  },
  {
    path: 'deviceneedstobelinked',
    component: DeviceNeedsToBeLinkedComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthenticationRoutingModule {}
